import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  WebExpertsLogo,
  WebSucessProLogo,
  WebGoodFirmsLogo,
  WebClutchRatingLogo,
} from "../../../app-constants";

const Ratingusa = () => {
  return (
    <div className="rating_usa rating_web_dev tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">{WebExpertsLogo}</div>
              <div className="rating-content">
                <div className="rating-num">60+</div>
                <p>Web Experts</p>
              </div>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">{WebSucessProLogo}</div>
              <div className="rating-content">
                <div className="rating-num">200+</div>
                <p>Successful Projects</p>
              </div>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">{WebGoodFirmsLogo}</div>
              <div className="rating-content">
                <div className="rating-num">5.0</div>
                <p>GoodFirms Rating</p>
              </div>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">{WebClutchRatingLogo}</div>
              <div className="rating-content">
                <div className="rating-num">4.8</div>
                <p>Clutch Rating</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ratingusa;
